module.exports = __webpack_public_path__ + "img/headLogo.0f592f78.png";